import { useState, type ReactNode } from 'react';

export function SettingsSection({ title, children }: { title: string; children: ReactNode }) {
  const [open, setOpen] = useState(true);
  return <details className="editor-settings-section" open={open} onToggle={event => setOpen(event.currentTarget.open)}>
    <summary>{title}</summary><div className="editor-settings-section-body">{children}</div>
  </details>;
}
